import type { FaireProductEntity } from "../../entity_types/product";

export const p_dq5w4b1q2o: FaireProductEntity = {
  token: "p_dq5w4b1q2o",
  type: "product",
  name: "Zigzag Coconut Bowl",
  brandName: "Rainforest Bowls",
  imageUrl:
    "https://cdn.faire.com/fastly/72e486e1f3c173967c6885def1cd44a8fe4987addeaa4bb46daca66597355b15.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/014490c47bb5fc0e93149a1905367b31769d4b9be0894fb8e3b281e198d96ef5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
